module.exports = __webpack_public_path__ + "static/img/fwzc_05.68feaa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_05.png
// module id = JrIB
// module chunks = 2